export const ErrorMessages = Object.freeze({
  REQUIRED: 'This field is mandatory.',
  VALID_PHONE_NUMBER: 'Please enter a valid phone number: (###) ###-#### or ###-###-####',
  VALID_POSTAL_CODE_NUMBER: 'Please enter a valid postal code number.',
  NOT_BLANK_MESSAGE: 'This field cannot be blank.',
});
